import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";

import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Input } from '../../../components/input'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { SelectInput } from "../../../components/select/select";

//Registration schema
const schema = yup.object().shape({
    studentId: yup.string().required("Student ID is a required field"),
    class: yup.string().required("Class is a required field"),
    term: yup.string().required("Term is a required field"),
    department: yup.string().required("Department is a required field"),
    subject: yup.string().required("Subject is a required field"),
    assignmentScore: yup.string().required("Assignment Score is a required field"),
    examinationScore: yup.string().required("Examination Score is a required field"),
});

const ResultsUpload = () => {
    const subjectOptions = [
        {
            value: "english",
            label: "English Language",
        },
        {
            value: "mathematics",
            label: "Mathematics",
        },
    ];
    const termOptions = [
        {
            value: "firstTerm",
            label: "First TERM",
        },
        {
            value: "secondTerm",
            label: "Second Term",
        },
    ];
    const classOptions = [
        {
            value: "jss1",
            label: "JSS 1",
        },
        {
            value: "jss2",
            label: "JSS 2",
        },
    ];

    const {
        handleSubmit,
        register,
        control,
        formState: { errors },
        // watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
    }

    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container >
                    <MainContent>
                        <Heading>
                            Results
                        </Heading>
                        <Breadcrumb
                            crumbs={['Results', "Upload"]}
                        />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <InputWrapper>
                                <Input
                                    id="resultStudentId"
                                    label="student id"
                                    type="text"
                                    placeholder="010-Bidemi Ajala"
                                    {...register("studentId")}
                                    error={errors.studentId?.message}
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper className="grid-2-2">
                                <Input
                                    id="resultClass"
                                    label="Class"
                                    type="text"
                                    {...register("class")}
                                    error={errors.class?.message}
                                    fullWidth
                                />
                                <Controller
                                    control={control}
                                    name="term"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="term"
                                                type="text"
                                                label="term"
                                                placeholder="Select Term"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.term?.message}
                                                options={termOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Controller
                                    control={control}
                                    name="department"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="department"
                                                type="text"
                                                label="department"
                                                placeholder="Select Department"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.department?.message}
                                                options={classOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Controller
                                    control={control}
                                    name="subject"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="subject"
                                                type="text"
                                                label='subject'
                                                placeholder="Select Subject"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.subject?.message}
                                                options={subjectOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Input
                                    id="resultAssignmentScore"
                                    label="Assignment Score"
                                    type="text"
                                    {...register("assignmentScore")}
                                    error={errors.assignmentScore?.message}
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Input
                                    id="resultExaminationScore"
                                    label="Examination Score"
                                    type="text"
                                    {...register("examinationScore")}
                                    error={errors.examinationScore?.message}
                                    fullWidth
                                />
                            </InputWrapper>
                            <Button
                                type="submit"
                                style={{ marginLeft: 'auto', marginTop: '6rem' }}
                                responsive
                            >
                                UPLOAD
                            </Button>
                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper >
    )
}

export default ResultsUpload
